module.exports = __webpack_public_path__ + "assets/img/oneback.9c99c832.png";